import type { Ui } from '@silvertours/front-shared';

export const FORM_NAME = 'regionalSettings';

export const FIELD_NAMES = {
  CURRENCY: 'currency',
  REDIRECT: 'redirect',
} as const;

/** Markets offering a dedicated site the country picker can redirect to. */
export const DEDICATED_SITES: Ui.FlagCountry[] = ['DE', 'FR', 'CH'];

type RedirectEnvironment = 'test' | 'stage' | 'production';

/**
 * Dedicated host per market and environment. The scheme and port are taken from
 * the current URL, so only the host is hardcoded here. The markets match the
 * `DEDICATED_SITES` list.
 */
export const REDIRECT_HOSTS: Record<
  RedirectEnvironment,
  Record<string, string>
> = {
  test: {
    DE: 'de.carspa.local',
    FR: 'fr.carspa.local',
    CH: 'ch.carspa.local',
  },
  stage: {
    DE: 'stage.billiger-mietwagen.de',
    FR: 'stage.carigami.fr',
    CH: 'stage.billiger-mietwagen.ch',
  },
  production: {
    DE: 'www.billiger-mietwagen.de',
    FR: 'www.carigami.fr',
    CH: 'www.billiger-mietwagen.ch',
  },
};
